import { Box } from "@mui/material";
import { styled as muiStyled } from '@mui/material/styles';
import { fontSize, textAlign } from "@mui/system";
import { thirdly2 } from "styles/theme";

export const VersionStyles = muiStyled(Box)(({ theme }) => ({
    marginTop: 20,
    flexGrow: 1,
    display: "flex",
    boxSizing: "border-box",
    overflow: "auto",
    '.wrap-assessment-versions': {
        border: `2px solid ${thirdly2}`,
        padding: 20,
        borderRadius: 8,
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        overflow: "auto",
        width: "70%"
    },
    '.assessment-versions': {
        display: "flex",
        columnGap: 10,
        boxSizing: "border-box",
        overflow: "auto",
        height: "100%"
    }
}));

export const ComparisonStyles = muiStyled(Box)(({ theme }) => ({
    width: 540,
    overflow: "auto",
    '.checker-name': {
        fontSize: 20,
        textAlign: "center"
    },
    '.words': {
        display: "flex",
        justifyContent: "center",
        columnGap: 5
    },
    '.version-words': {
        display: "flex",
        flexDirection: "column",
        rowGap: 10
    }
}));

export const VersionCardStyles = muiStyled(Box)(({ theme }) => ({
    height: "100%",
    width: "50%",
    // padding: "20",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    rowGap: 20,
    '.version-header': {
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        rowGap: 10,
        justifyContent: "space-between",
    },
    '.select-version': {
        width: 320,
        marginTop: 10
    },
    '.version-card': {
        width: "100%",
        // background: "white",
        borderRadius: 2,
        height: "100%",
        flexGrow: 1,
        boxSizing: "border-box"
    }

}));